import * as React from 'react';
import {useCallback, useEffect, useRef, useState} from 'react';
import {
    //fetchRelatedRecords,
    useNotify,
    useListContext, useRefresh,
} from 'ra-core';
import {Box, Button, useMediaQuery} from "@material-ui/core";
import {fetchJson as httpClient} from "../../utils/keycloak";
import DownloadIcon from "@material-ui/icons/GetApp";
import config from "../../utils/config";
import CircularProgress from '@mui/material/CircularProgress';
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
import {useLocale, useTranslate} from "react-admin";
import Asynchronous2 from "../../_common/AsynchronousRequests2";
// import {Typography} from "@mui/material";
// import dataProvider from "../../utils/dataProvider";

const defaultIcon = <DownloadIcon/>;

const HandlerAddDelProductGroup = (props) => {
    const {
        onClick,
        label,
        type,
        //icon=false,
    } = props;
    const {
        resource,
        selectedIds,
        // filterValues,
    } = useListContext(props);

    const refresh = useRefresh();
    //const exporter = customExporter || exporterFromContext;
    const translate = useTranslate();
    const locale = useLocale();
    const isSmall = useMediaQuery(function (theme) {
        return theme.breakpoints.down('sm'); //xs  sm
    });
    const notify = useNotify();

    const [form, setForm] = useState({
        productsGroup: null, //[],
    });

    const [openDialog, setOpenDialog] = useState(false);

    const [loading, setLoading] = useState(false);


    const getData = async (type) => {
        let url = {
            del: `api/products/bulk/delete-category`,
            add: `api/products/bulk/add-category`,
        };
        let myUrl = `${config.apiUrl}${url[type]}`

        let data = {
            "product_ids": selectedIds,
            "group_id": form.productsGroup.id
        }
        try {
            // const response = await httpClient(myUrl);
            const response = await httpClient(myUrl, {
                method: 'post',
                body: JSON.stringify(data)
            })
            if (response.status >= 200 && response.status <= 300) {
                const {json} = response
                const {message} = json || {}
                // console.log('response=========>', response);
                notify(message, {type: 'info', autoHideDuration: 8000,});
                setOpenDialog(false)
                // dataProvider.getMany('dProducts', { ids: selectedIds });
                refresh();
            } else {
                notify(`ERROR ${response.status}`, {type: 'error', autoHideDuration: 8000,});
            }
        } catch (err) {
            console.log('err=======>', err);
            notify(err, {type: 'error',});
        } finally {
            //console.log('finally=======>', 'finally');
        }
    }

    /*const handleClick = useCallback(
        event => {
            getData();
            if (typeof onClick === 'function') {
                onClick(event);
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [notify, onClick, resource, selectedIds]
    );*/

    const handleClickDel = () => {
        getData('del')
    }
    const handleClickAdd = () => {
        getData('add')
    }

    const handleChangeSel = (name, val) => {
        setForm(form => ({
            ...form,
            [name]: val,
        }));
    };

    return (
        <>
            <Button
                style={{marginLeft: selectedIds.length > 0 && 24, marginTop: selectedIds.length > 0 && -4}}
                color={"primary"}
                // onClick={handleClick}
                onClick={(event) => {
                    setOpenDialog(true)
                }}
                label={label}
            >
                {defaultIcon}{label}
            </Button>

            <Dialog
                maxWidth={isSmall ? 'xs' : 'md'}
                open={openDialog}
                onClose={(event) => {
                    setOpenDialog(false)
                }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {label}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" style={{width: isSmall ? 400 : 800}}>
                        <span><b>ID</b> = {selectedIds.join(', ')}</span>
                        <Box mt={2} fullWidth>
                            {/*<Typography variant="h6" component="h6" color={'textPrimary'}>
                                {translate('Categories')}
                            </Typography>*/}
                            <Box style={{display: isSmall ? 'grid' : 'flex'}} display="flex" alignItems={"top"}>
                                <Box flex={2} p={"0.5em"}>
                                    <Asynchronous2
                                        limit={30}
                                        // multiple={true}
                                        label={translate('Categories')}
                                        value={form.productsGroup}
                                        setValue={(value) => handleChangeSel('productsGroup', value)}
                                        // domain={config.apiPrices}
                                        url={'api/react-admin/main/ProductsGroup'}
                                        // filter={'&discount_property_id=60'}
                                        // outputField='id'
                                        searchField={'search'}
                                        getOptionLabel={(option) => `${option['name_' + locale]}`}
                                        sort={`name_${locale}`}
                                        // error={form.customers[index].error?.base_warehouse_main_supplier}
                                    />
                                </Box>
                            </Box>
                        </Box>
                    </DialogContentText>
                </DialogContent>
                <DialogActions style={{padding: 24}}>
                    <Box flex={1} textAlign={'start'}>
                        {form.productsGroup &&
                            <Button
                                // disabled={form.productsGroup.length === 0}
                                variant="contained"
                                onClick={handleClickAdd}
                                color="primary"
                                // autoFocus
                            >
                                {translate('Add Categories')}
                            </Button>

                        }
                    </Box>
                    <Box flex={1} textAlign={'start'}>
                        {form.productsGroup &&
                            <Button
                                // disabled={form.productsGroup.length === 0}
                                style={{backgroundColor: 'red'}}
                                variant="contained"
                                onClick={handleClickDel}
                                color="primary"
                                // autoFocus
                            >
                                {translate('Delete Categories')}
                            </Button>
                        }
                    </Box>
                    <Box flex={1} textAlign={'end'}>
                        <Button
                            variant="contained"
                            onClick={(event) => {
                                setOpenDialog(false)
                            }}
                            color="error" autoFocus>
                            CLOSE
                        </Button>
                    </Box>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default HandlerAddDelProductGroup;
